import React, { useState, useEffect } from "react";
import DocMinter from "../DocMinter.json";

import Loading from "react-loading";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import connectWallet from "../interact/connectWallet";
import connectedWallets from "../interact/connectedWallets";

const Search = () => {
  const ethers = require("ethers");

  const [data, setData] = useState([]);
  const [CIN, setCIN] = useState("");
  const [dataLoading, setDataLoading] = useState(false);

  const [connectButton, setConnectButton] = useState(false);
  const [address, setAddress] = useState("");
  const [status, setStatus] = useState("");

  function handleCIN(e) {
    console.log(e.target.value);
    setCIN(e.target.value);
  }

  async function getCinToId() {
    setDataLoading(true);
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();

    let contract = new ethers.Contract(
      DocMinter.address,
      DocMinter.abi,
      signer
    );
    try {
      let calling = await contract.getData();
      setData(calling);
      console.log(calling);
    } catch (error) {
      alert(error);
      toast("Only for the owner of smart contract!", { type: "error" });
    }
    setDataLoading(false);
  }

  async function connectWalletPressed() {
    setConnectButton(true);
    const response = await connectWallet();
    setAddress(response.address);
    setStatus(response.status);
    setConnectButton(false);
    if (response.address.length > 0) {
      toast("Connected successfully!", { type: "success" });
    } else {
      toast("Please install Metamask!", { type: "warning" });
    }
  }

  function walletListener() {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          setAddress(accounts[0]);
        } else {
          setAddress("");
        }
      });
    } else {
      return <div>Install metamask</div>;
    }
  }

  useEffect(() => {
    async function fetchData() {
      const response = await connectedWallets();
      setAddress(response);
    }

    fetchData();
    walletListener();
  }, []);

  return (
    <div className="cinGetter">
      <ToastContainer />
      <h1>Search file Ids</h1>
      <button className="connectWallet" onClick={connectWalletPressed}>
        {address.length > 0 ? (
          "Connected: " +
          String(address).substring(0, 6) +
          "..." +
          String(address).substring(38)
        ) : (
          <span className="beforeConnecting">Connect wallet</span>
        )}
      </button>
      {connectButton && (
        <div className="loading-modal">
          <Loading type="spin" color="black" height={20} width={20} />
        </div>
      )}
      <span className="status">{status}</span>
      <label htmlFor="cin">
        <input
          type="text"
          onChange={handleCIN}
          placeholder="Enter your CIN..."
        />
        <br />
        <button className="getIds" onClick={getCinToId}>
          Get Ids
        </button>
        <br />
        <br />
        {/* <span>
          {id ? (
            <span>
              {docType} with id of : {id}
            </span>
          ) : (
            <span></span>
          )}
        </span> */}
        {data.map((val, key) => {
          return (
            <span key={key}>
              {val._userCIN === CIN && (
                <span>
                  {val._fileDocName} has id of {val._fileId.toString()}
                  <br />
                </span>
              )}
            </span>
          );
        })}
      </label>
      {dataLoading && (
        <div className="loading-modal">
          <Loading type="spin" color="black" height={50} width={50} />
        </div>
      )}
    </div>
  );
};

export default Search;
